import React from 'react';
// --- INICIO DE LA MODIFICACIÓN 1: Se importa LangLink en lugar de NavLink ---
import { LangLink } from '../../components/common/LangLink';
import { useLocation } from 'react-router-dom';
// --- FIN DE LA MODIFICACIÓN 1 ---
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faShieldAlt,
  faCreditCard,
  faBell,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

const SettingsNav = () => {
  const { t, i18n } = useTranslation();
  // --- INICIO DE LA MODIFICACIÓN 2: Se añade la lógica para 'isActive' ---
  const location = useLocation();

  // Se extrae el prefijo de idioma para una comparación correcta
  const currentPathWithoutLang = location.pathname.startsWith(
    `/${i18n.language}`
  )
    ? location.pathname.substring(i18n.language.length + 1)
    : location.pathname;

  const isActive = (path) => currentPathWithoutLang.startsWith(path);
  // --- FIN DE LA MODIFICACIÓN 2 ---

  const navItems = [
    {
      to: '/my/settings/profile',
      icon: faUser,
      label: t('settings.nav.profile'),
    },
    {
      to: '/my/settings/account',
      icon: faShieldAlt,
      label: t('settings.nav.account'),
    },
    {
      to: '/my/settings/payments',
      icon: faCreditCard,
      label: t('settings.nav.payments'),
    },
    {
      to: '/my/settings/notifications',
      icon: faBell,
      label: t('settings.nav.notifications'),
    },
    {
      to: '/my/settings/danger-zone',
      icon: faExclamationTriangle,
      label: t('settings.nav.danger_zone'),
      isDanger: true,
    },
  ];

  const linkClasses =
    'flex items-center gap-3 px-4 py-3 rounded-lg font-semibold transition-colors duration-200';
  const normalClasses =
    'text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700/50';
  const dangerClasses =
    'text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30';
  const activeClasses = 'bg-primary/10 text-primary dark:bg-primary/20';

  return (
    <nav className="flex flex-col gap-2">
      {navItems.map((item) => (
        // --- INICIO DE LA MODIFICACIÓN 3: Se usa LangLink y la nueva lógica de 'isActive' ---
        <LangLink
          key={item.to}
          to={item.to}
          className={`${linkClasses} ${
            isActive(item.to)
              ? activeClasses
              : item.isDanger
              ? dangerClasses
              : normalClasses
          }`}
        >
          <FontAwesomeIcon icon={item.icon} className="w-5 text-center" />
          <span>{item.label}</span>
        </LangLink>
        // --- FIN DE LA MODIFICACIÓN 3 ---
      ))}
    </nav>
  );
};

export default SettingsNav;
